import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// ALL ROLES TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names for all roles table
 */
export const ALL_ROLES_DEFAULT_COLUMNS = {
  NAME: 'name',
  DESCRIPTION: 'description',
} as const;

/**
 * Flexible column property names for all roles table
 */
export const ALL_ROLES_FLEXIBLE_COLUMNS = {} as const;

/**
 * Action column property name for all roles table
 */
export const ALL_ROLES_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order for all roles table
 */
export const ALL_ROLES_DEFAULT_COLUMNS_ORDER: string[] = [
  ALL_ROLES_DEFAULT_COLUMNS.NAME,
  ALL_ROLES_DEFAULT_COLUMNS.DESCRIPTION,
];

/**
 * Flexible columns array for all roles table
 */
export const ALL_ROLES_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const ALL_ROLES_COLUMNS: TableColumn[] = [
  {
    label: 'configuration.roles.table.role_code',
    prop: ALL_ROLES_DEFAULT_COLUMNS.NAME,
    width: 360,
    type: 'custom',
  },
  {
    label: 'configuration.roles.table.description',
    prop: ALL_ROLES_DEFAULT_COLUMNS.DESCRIPTION,
    width: 200,
  },
  {
    label: 'configuration.roles.table.actions',
    prop: ALL_ROLES_ACTION_COLUMN.ACTIONS,
    width: 150,
    align: 'center',
    type: 'actions',
  },
];

// ============================================================================
// CHILD ROLES TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names for child roles table
 */
export const CHILD_ROLES_DEFAULT_COLUMNS = {
  NAME: 'name',
  DESCRIPTION: 'description',
} as const;

/**
 * Flexible column property names for child roles table
 */
export const CHILD_ROLES_FLEXIBLE_COLUMNS = {} as const;

/**
 * Action column property name for child roles table
 */
export const CHILD_ROLES_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order for child roles table
 */
export const CHILD_ROLES_DEFAULT_COLUMNS_ORDER: string[] = [
  CHILD_ROLES_DEFAULT_COLUMNS.NAME,
  CHILD_ROLES_DEFAULT_COLUMNS.DESCRIPTION,
];

/**
 * Flexible columns array for child roles table
 */
export const CHILD_ROLES_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const CHILD_ROLES_COLUMNS: TableColumn[] = [
  {
    label: 'configuration.roles.table.role_code',
    prop: CHILD_ROLES_DEFAULT_COLUMNS.NAME,
    width: 360,
    type: 'custom',
  },
  {
    label: 'configuration.roles.table.description',
    prop: CHILD_ROLES_DEFAULT_COLUMNS.DESCRIPTION,
    width: 200,
  },
  {
    label: 'configuration.roles.table.actions',
    prop: CHILD_ROLES_ACTION_COLUMN.ACTIONS,
    width: 150,
    align: 'center',
    type: 'actions',
  },
];

// ============================================================================
// PERMISSIONS TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names for permissions table
 */
export const PERMISSIONS_DEFAULT_COLUMNS = {
  NAME: 'name',
  DESCRIPTION: 'description',
} as const;

/**
 * Flexible column property names for permissions table
 */
export const PERMISSIONS_FLEXIBLE_COLUMNS = {} as const;

/**
 * Action column property name for permissions table
 */
export const PERMISSIONS_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order for permissions table
 */
export const PERMISSIONS_DEFAULT_COLUMNS_ORDER: string[] = [
  PERMISSIONS_DEFAULT_COLUMNS.NAME,
  PERMISSIONS_DEFAULT_COLUMNS.DESCRIPTION,
];

/**
 * Flexible columns array for permissions table
 */
export const PERMISSIONS_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const PERMISSIONS_COLUMNS: TableColumn[] = [
  {
    label: 'configuration.roles.table.permission_code',
    prop: PERMISSIONS_DEFAULT_COLUMNS.NAME,
    type: 'text',
    align: 'left',
    sortable: false,
  },
  {
    label: 'configuration.roles.table.description',
    prop: PERMISSIONS_DEFAULT_COLUMNS.DESCRIPTION,
    type: 'text',
    align: 'left',
    sortable: false,
  },
];

// ============================================================================
// MEMBERS/USERS TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names for members table
 */
export const MEMBERS_DEFAULT_COLUMNS = {
  USERNAME: 'username',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
} as const;

/**
 * Flexible column property names for members table
 */
export const MEMBERS_FLEXIBLE_COLUMNS = {} as const;

/**
 * Action column property name for members table
 */
export const MEMBERS_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order for members table
 */
export const MEMBERS_DEFAULT_COLUMNS_ORDER: string[] = [
  MEMBERS_DEFAULT_COLUMNS.USERNAME,
  MEMBERS_DEFAULT_COLUMNS.EMAIL,
  MEMBERS_DEFAULT_COLUMNS.FIRST_NAME,
  MEMBERS_DEFAULT_COLUMNS.LAST_NAME,
];

/**
 * Flexible columns array for members table
 */
export const MEMBERS_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const MEMBERS_COLUMNS: TableColumn[] = [
  {
    label: 'configuration.roles.table.username',
    prop: MEMBERS_DEFAULT_COLUMNS.USERNAME,
    type: 'text',
  },
  {
    label: 'configuration.roles.table.email',
    prop: MEMBERS_DEFAULT_COLUMNS.EMAIL,
    type: 'text',
  },
  {
    label: 'configuration.roles.table.first_name',
    prop: MEMBERS_DEFAULT_COLUMNS.FIRST_NAME,
    type: 'text',
  },
  {
    label: 'configuration.roles.table.last_name',
    prop: MEMBERS_DEFAULT_COLUMNS.LAST_NAME,
    type: 'text',
  },
];
